import { UPDATE_ANSWERS } from 'client/constants/actions';

type RegularAnswerPayload = {
	cardId: string;
	answerId: string;
	votes?: { [answerId: string]: number }; // published version only
};

type PollMultipleAnswerPayload = {
	cardId: string;
	answerId: string;
	data: { textContent?: string; embedCode?: string };
};

type SubmitCardAnswersPayload = {
	cardId: string;
	submitted: boolean;
	votes?: { [answerId: string]: number }; // published version only
};

type SortableTriviaAnswerPayload = {
	cardId: string;
	answerId: string;
	submitted: boolean;
	data: { isCorrect: boolean; textContent?: string };
};

export type UpdateUserAnswersPayload =
	| RegularAnswerPayload
	| PollMultipleAnswerPayload
	| SubmitCardAnswersPayload
	| SortableTriviaAnswerPayload;

// Store selected answer ids and data
export function updateAnswers(payload: UpdateUserAnswersPayload) {
	return {
		type: UPDATE_ANSWERS,
		payload,
	};
}
